const initialState = {
    callIsActive: false,
    callDetails: {},
    isHangingUp: false,
    isCalling: false,
    isTransferringCall: false,
    isResolvingCallResult: false,
    isDroppingVoicemail: false
}

export default initialState;
